export const setTheme = (color) => {
  document.documentElement.removeAttribute("style");
  const colorBlack = {
    "--bg-header": "#222924",
    "--text-header": "#FFFFFF",
    "--text-hover": "#86C232", //2F76DB
    "--bg-btn": "#86C232",
    "--text-primary": "#FFFFFF",
    "--bg-body": "#222924",
    "--bg-menu": "#FFFFFF",
    "--bg-secondary": "#222629",
  };
  const colorWhite = {
    "--bg-header": "#e1f2e9",
    "--text-header": "#000",
    "--text-hover": "#86C232",
    "--bg-btn": "#86C232",
    "--text-primary": "#000000",
    "--bg-body": "#e1f2e9",
    "--bg-menu": "#FFFFFF",
    "--bg-secondary": "#ebf7f0",
  };
  const colors = color ? colorBlack : colorWhite;
  for (const item in colors) {
    document.documentElement.style.setProperty(
      item,
      color ? colorWhite?.[item] : colorBlack?.[item]
    );
  }
  return;
};

export const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
};

export const slugToTitle = (slug) => {
  const words = slug.split("-");
  const title = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return title;
};